import React, { useEffect } from "react";
import Page from "../../layout/Page";

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, []);
  return (
    <Page
      title="Privacy Policy - Shoora"
      description=""
      keywords="telematics, AI, IoT, fleet safety, road safety, logistics"
    >
      <div className="legal-header container py-3 border-bottom border-warning ">
        <h1 className="bold text-center">Privacy Policy</h1>
      </div>
      <div className="container">
        <p>
          <strong>Effective Date</strong>: 1st January 2025
        </p>

        <p>
          Shoora.com is a property of MashEye Infotech Pvt. Ltd. (referred to as
          "Shoora," "we," "our," or "us"). At Shoora, we are committed to
          protecting and respecting your privacy. This Privacy Policy outlines
          how we collect, use, disclose, and safeguard your information when you
          visit our website (Shoora.com) and interact with our products,
          including our DSM Camera, ADAS Camera, and AI-enabled technologies. By
          using our website and products, you consent to the practices described
          in this policy.
        </p>

        <h4>1. Information We Collect</h4>
        <p>
          We collect both personal and non-personal information in connection
          with your use of our website and products. This includes:
        </p>
        <ul className="text-dark">
          <li className="text-dark">
            <strong>Personal Information:</strong> When you interact with our
            website or products, you may provide us with personal information
            such as your name, email address, phone number, and payment details.
          </li>
          <li className="text-dark">
            <strong>Device and Usage Information:</strong> We may collect
            information about the devices and browsers you use to access our
            website, such as IP addresses, browser type, operating system, and
            usage data like pages visited and time spent on the site.
          </li>
          <li className="text-dark">
            <strong>Data from Shoora Products:</strong> Our DSM Camera and ADAS
            Camera systems collect and process information such as vehicle
            status, driver behavior (e.g., fatigue, distraction, mobile usage),
            and environmental data (e.g., pedestrians, proximity alerts). These
            devices use AI technology to analyze data and provide safety
            warnings.
          </li>
        </ul>

        <h4>2. How We Use Your Information</h4>
        <p>We use the information we collect for the following purposes:</p>
        <ul className="text-dark">
          <li className="text-dark">
            <strong>
              To operate, maintain, and improve our website and products,
              including the DSM Camera, ADAS Camera, and AI technologies.
            </strong>
          </li>
          <li className="text-dark">
            <strong>
              To send you communications related to your inquiries, account, or
              product use, such as updates, safety alerts, and promotional
              offers.
            </strong>
          </li>
          <li className="text-dark">
            <strong>
              To analyze data from Shoora’s products to improve safety features
              and enhance user experience.
            </strong>
          </li>
          <li className="text-dark">
            <strong>
              To personalize your experience on our website, ensuring the most
              relevant and effective content and services are provided.
            </strong>
          </li>
          <li className="text-dark">
            <strong>
              To comply with legal requirements and resolve any legal disputes.
            </strong>
          </li>
        </ul>
        <h4>3. AI and Camera Data Usage</h4>
        <p>
          Shoora’s products, such as the DSM Camera and ADAS Camera, utilize
          advanced AI technology to analyze data in real time. These cameras
          capture video and sensor data related to driver behavior, vehicle
          surroundings, and road conditions. The AI system processes this data
          to provide safety features like:
        </p>
        <ul className="text-dark">
          <li className="text-dark">
            <strong>Driver Monitoring:</strong> Identifies signs of driver
            distraction, fatigue, and mobile phone use.
          </li>
          <li className="text-dark">
            <strong>ADAS Features:</strong> Provides Lane Departure Warning,
            Pedestrian Detection, and Forward Collision Warning, among other
            safety alerts.
          </li>
          <li className="text-dark">
            <strong>Data Retention:</strong> We do not retain your camera data
            unless necessary for product functionality or as required by law.
            Any data stored is anonymized or aggregated when possible.
          </li>
        </ul>

        <h4>4. Data Sharing and Disclosure</h4>
        <p>
          We do not sell, rent, or trade your personal information. However, we
          may share your data in the following situations:
        </p>
        <ul className="text-dark">
          <li className="text-dark">
            <strong>Service Providers:</strong> We may share data with trusted
            third-party service providers who assist with operations, such as
            website hosting, payment processing, and product support.
          </li>
          <li className="text-dark">
            <strong>Legal Compliance:</strong> We may disclose your information
            to comply with applicable laws, legal processes, or government
            requests.
          </li>
          <li className="text-dark">
            <strong>Business Transfers:</strong> In the event of a merger,
            acquisition, or asset sale, your information may be transferred as
            part of the transaction.
          </li>
        </ul>

        <h4>5. Data Security</h4>
        <p>
          We employ reasonable security measures to protect your personal
          information from unauthorized access, alteration, or disclosure.
          However, please note that no method of transmission over the internet
          or electronic storage is 100% secure. While we strive to protect your
          information, we cannot guarantee its absolute security.
        </p>

        <h4>6. Your Rights and Choices</h4>
        <p>
          You have the right to access, correct, or delete the personal
          information we collect from you. You may also opt out of receiving
          marketing communications by following the unsubscribe instructions in
          our emails or contacting us directly.
        </p>

        <h4>7. Cookies and Tracking Technologies</h4>
        <p>
          We use cookies and similar technologies to improve your experience on
          our website. These technologies collect information about your
          browsing activities to personalize content, provide analytics, and
          improve our services. You can adjust your browser settings to refuse
          cookies or alert you when cookies are being sent.
        </p>

        <h4>8. Third-Party Links</h4>
        <p>
          Our website may contain links to third-party sites or services that
          are not operated by Shoora. We are not responsible for the content,
          privacy policies, or practices of any third-party sites.
        </p>

        <h4>9. Children’s Privacy</h4>
        <p>
          Shoora’s products and website are not intended for children under the
          age of 13. We do not knowingly collect personal information from
          children. If we become aware that we have collected data from a child
          under 13, we will take steps to delete that information.
        </p>

        <h4>10. Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date. We encourage
          you to review this policy periodically to stay informed about how we
          are protecting your information.
        </p>

        <h4>11. Contact Us</h4>
        <p>
          If you have any questions or concerns about this Privacy Policy or how
          we handle your data, please contact us at:
        </p>
        <p>
          <strong>Shoora.com</strong> <br />A Property of MashEye Infotech Pvt.
          Ltd. <br />
          Unit 914A, 9th Floor, BPTP Park Centra, Sector - 30, Gurugram - 122002{" "}
          <br />
          Email: info@shoora.com <br />
          Phone: +91 97287 46672
        </p>
        <p>
          By using Shoora’s products and services, you acknowledge that you have
          read and understand this Privacy Policy.
        </p>
      </div>
    </Page>
  );
};

export default PrivacyPolicy;
